import { render } from "./InternalFooter.vue?vue&type=template&id=ed8d430e&scoped=true"
import script from "./InternalFooter.vue?vue&type=script&lang=js"
export * from "./InternalFooter.vue?vue&type=script&lang=js"

import "./InternalFooter.vue?vue&type=style&index=0&id=ed8d430e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed8d430e"]])

export default __exports__